import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/WeatherDashboardBasic.css';

interface BasicWeather {
  temperature: number;
  condition: string;
  humidity: number;
  windSpeed: number;
  location: string;
}

const WeatherDashboardBasic: React.FC = () => {
  const [weather, setWeather] = useState<BasicWeather | null>(null);
  const [location, setLocation] = useState('New York');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setWeather({
        temperature: 72,
        condition: 'Sunny',
        humidity: 65,
        windSpeed: 10,
        location: location
      });
      setLoading(false);
    }, 1000);
  }, [location]);

  const handleLocationChange = (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const input = form.elements.namedItem('location') as HTMLInputElement;
    setLocation(input.value);
  };

  if (loading) {
    return (
      <div className="weather-basic-loading">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="weather-dashboard-basic">
      <div className="header-basic-weather">
        <Link to="/" className="back-button-basic-weather">← Back</Link>
        <h1>Weather App</h1>
        <span className="version-badge-basic-weather">Synoppy 1.0</span>
      </div>

      <div className="location-form">
        <form onSubmit={handleLocationChange}>
          <input
            type="text"
            name="location"
            placeholder="Enter city name"
            className="location-input"
          />
          <button type="submit" className="location-submit">Get Weather</button>
        </form>
      </div>

      {weather && (
        <div className="weather-info">
          <div className="weather-card-basic">
            <h2>{weather.location}</h2>
            <div className="temperature-basic">{weather.temperature}°F</div>
            <div className="condition-basic">{weather.condition}</div>
            
            <div className="weather-details-basic">
              <div className="detail-basic">
                <strong>Humidity:</strong> {weather.humidity}%
              </div>
              <div className="detail-basic">
                <strong>Wind Speed:</strong> {weather.windSpeed} mph
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="upgrade-section-basic">
        <Link to="?version=1.5" className="upgrade-link-basic">
          Try Synoppy 1.5 Advanced Version →
        </Link>
      </div>
    </div>
  );
};

export default WeatherDashboardBasic;